<template>
	<div>
		<div
			v-if="$window.location.origin.includes('test')"
			class="banner"
			style="background-color:#03B3B2;color:white;"
		>TEST</div>
		<div
			v-if="$window.location.origin.includes('localhost')"
			class="banner"
			style="background-color:#82BA00;color:white;"
		>DEVELOPMENT</div>
		
		<div 
			v-show="vchat.dialog && !vchat.isTransition && $store.state.principal.chatUserToken" 
			class="vchat-lounge" 
			:style="{
				height: vchatDialogHeight,
				width : vchatDialogWidth
			}"
		>
			<v-icon style="font-size: 30px !important; position: absolute; right: 10px; top: 10px;" color="red" large @click="closeDialog()">mdi-close-circle-outline</v-icon>
			<iframe
				v-if="vchat.isOpenChat == false" 
				:src="$vchaturl + '/frontend/?e=' + $store.state.principal.chatEventToken + 
					'&r=' + vchat.chatRoomToken +
					'&u=' + $store.state.principal.chatUserToken + 
					'&o=&i=&sr=1&sm=1&seu=1&sru=1&bc=1'+
					'&cd='+vchat.chatdisplay" 
				style="height:100%; width: 98%"
				allow="camera; microphone;"
			></iframe>
			<iframe
				v-else
				:src="$vchaturl + '/frontend/?e=' + $store.state.principal.chatEventToken + 
					'&r=' + vchat.chatRoomToken +
					'&u=' + $store.state.principal.chatUserToken + 
					'&o=&i=&sr=1&sm=1&seu=1&sru=1&bc=1&oc=' + vchat.openChatValue+
					'&cd='+vchat.chatdisplay" 
				style="height:100%; width: 98%"
				allow="camera; microphone;"
			></iframe>
		</div>

		<router-view :key="$route.fullPath" :vchat="vchat"></router-view>
		
		<v-fab-transition>
			<v-btn
				v-if="vchat.button && !vchat.isTransition && $store.state.principal.chatUserToken &&
				(showvchat==null || showvchat==true)"
				style="z-index: 203; border-radius: 50px"
				:style="{bottom: vchat.bottom}"
				class="ma-4 pa-2"
				fixed
				bottom
				right
				height="57px"
				color="#cfcdcd"
				small
				@click="showDialog()"
			>
				<v-icon large>mdi-message-outline</v-icon>
			</v-btn>
		</v-fab-transition>
	</div>
</template>

<style>
 /* Imported fonts for tinyMCE : if changed, update appendTinyMCECustomFonts */
@import url('https://fonts.googleapis.com/css2?family=Allerta&family=Comic+Neue&family=Inter&family=Noto+Sans+Symbols&family=Oswald:wght@700&family=Roboto&display=swap');
@font-face {
  font-family: "greek";
  src: local("greek"), url("/fonts/greek.ttf") format("truetype");
}

@font-face {
  font-family: "xingy dings";
  src: local("xingy_dings"), url("/fonts/xingy_dings.ttf") format("truetype");
}

@font-face {
  font-family: "fredoka one";
  src: local("fredoka_one"), url("/fonts/fredoka_one.ttf") format("truetype");
}

@font-face {
font-family: "abril fatface";
src: local("AbrilFatface-Regular"), url("/fonts/AbrilFatface-Regular.ttf") format("truetype");
}

@font-face {
font-family: "sacramento";
src: local("Sacramento-Regularr"), url("/fonts/Sacramento-Regular.ttf") format("truetype");
}
			
@font-face {
font-family: "ds sans";
src: local("DMSans-Regular"), url("/fonts/DMSans-Regular.ttf") format("truetype");
}

/* END Imported fonts for tinyMCE */

.loader {
	position: fixed;
	z-index: 88;
	top: 30%;
	left: 50%;
	transform: translateX(-50%);
}
div.application {
	font-family: "Open Sans", Helvetica, Arial, monospace, sans-serif;
	margin: 0px;
}
div.banner {
	position: absolute;
	left: 50%;
	transform: translateX(-50%);
	z-index: 9;
	padding: 5px 10px;
	border-radius: 0 0 5px 5px;
	font-family: "Open Sans", sans-serif;
}
/* primary */
button.v-unite-primary > span {
	color: white;
}
button.v-unite-primary {
	background-color: black !important;
}
button.v-unite-primary:hover {
	background-color: #eb6e1f !important;
}
a.v-unite-primary {
	color: black !important;
	font-weight: bold;
	text-decoration: none;
}
a.v-unite-primary:hover {
	color: #eb6e1f !important;
}
.v-list-item__title {
	font-size: 14px;
}

/* Animation hover underline */
.hover-underline {
	font-size: 500%;
	text-decoration: none;
	background: linear-gradient(#eb6e1f, #eb6e1f) bottom / 0 0.2em no-repeat;
	transition: 0.5s background-size;
}

.hover-underline:hover,
.hover-underline.v-btn--active {
	background-size: calc(100% - 32px) 0.2em;
}

.hover-underline.v-btn--active:hover:before,
.hover-underline.v-btn--active:before,
.hover-underline.v-btn:before {
	opacity: 0 !important;
}
.v-btn.hotspot_btn p{
	margin-bottom:0 !important;
}
.v-btn.hotspot_btn a{
	text-decoration:none !important;
}
.v-btn.hotspot_btn span{
	display:inline-block !important;
}
.hotspot_text > p{
	margin-bottom: 0 !important;
	line-height: normal !important;
}
.hotspot_embed_html > *{
	position: absolute !important;
	min-width: 100% !important;
	height: 100% !important;
}
.checkered_background {
	background-repeat: repeat;
	background-color: #F8F8F8;
	background-size: 50px 50px;
	background-position: 0 0, 25px 25px;
	background-image: linear-gradient(45deg, #CCC 25%, transparent 25%, transparent 75%, #CCC 75%, #CCC),
	linear-gradient(45deg, #CCC 25%, transparent 25%, transparent 75%, #CCC 75%, #CCC);
}

.v-tooltip__content {
	background-color: #F8F8F8 !important;
	color: black !important;
	border-color: grey;
	border-style: solid;
	border-width: thin;
	border-radius: 0;
}
div.vchat-lounge {
	position: fixed;
	right: 0;
	bottom: 0;
	z-index: 203;
	background-color:white;
	right: 0px;
}
</style>

<script>
import configuration from "./configuration";
import { CometChat } from "@cometchat-pro/chat";
import axios from 'axios'
import {eventBus} from './main';

export default {
	data() {
		return {
			chatRoomToken: null,
			vchat: {
				dialog: false,
				button: true,
				isTransition: false,
				bottom: '15px',
				chatRoomToken: null,
				isOpenChat:false,
				openChatValue: '',
				chatdisplay: 0
			},
			vchatDialogHeight: "75%",
			vchatDialogWidth: "450px",
			showvchat: null,
		};
	},
	created: async function () {
		this.initialize();
		eventBus.$on('openbubblechat', this.bubbleOpen);
	},
	mounted() {
		if (document.body.clientWidth < 600) {
			this.vchatDialogHeight = "100%"
		}
		if (document.body.clientWidth < 450) {
			this.vchatDialogWidth = "100%"
		}

	},
	methods: {
		bubbleOpen(el) {
			this.showDialogOpen(el);
		},
		initialize() {
			if (this.$store.state.principal.chatUserToken) {
				this.getChatRoomToken();
				this.vchat.button = true;
			}
			this.$store.commit("setIsUseCometChat", false);

			if(this.$store.state.principal.tenantSlug){
				if(this.$store.state.principal.tenantSlug==this.$router.app._route.params.tenantSlug){
					this.showvchat = true;
				} else {
					this.showvchat = false;
				}
			} 
			// 	console.log(this.$router.app._route.params.tenantSlug);
		},
		async initializeCometchat() {
			let cometChatSettings = new CometChat.AppSettingsBuilder()
				.subscribePresenceForAllUsers()
				.setRegion("us")
				.build();

			await CometChat.init(configuration.appIdCometChat, cometChatSettings).then(
				async () => {
					console.log("Initialization completed successfully");
				},
				async (error) => {
					console.log("Initialization failed with error:", error);
					let notification = {
						title: "CometChat error",
						content: {
							errorList: [error.message],
							fieldErrorList: [],
							noticeList: [],
							type: "NOTIFICATION",
						}
					};
					this.$store.commit("showNotification", notification);
				}
			);
		},
		getChatRoomToken() {
			if (this.$store.state.principal.chatEventToken) {
				axios
					.get("/system/vchat/lounge/room/firstRoom?eventToken=" + this.$store.state.principal.chatEventToken)
					.then(response => {
						if (response.data) {
							this.vchat.chatRoomToken = response.data.room_token;
						}
					})
					.catch(() => {});
				}
		},
		showDialog() {
			this.vchat.dialog = true;
			this.vchat.button = false;
			this.vchat.isOpenChat = false;
			this.vchat.openChatValue = '';
			this.vchat.chatdisplay = 1;
		},
		showDialogOpen(el) {
			this.vchat.dialog = true;
			this.vchat.button = false;
			this.vchat.isOpenChat = true;
			this.vchat.openChatValue = el;
		},
		closeDialog() {
			this.vchat.dialog = false;
			this.vchat.button = true;
			this.vchat.chatdisplay = 0;
		},
	},
};
</script>